@if (this.grid) {
  <cam-loader [isLoading]="this.requestState.isLoading()">
    <div class="cursor-nav">
      <cam-button
        type="secondary"
        size="small"
        icon="arrow-big-left"
        iconPosition="left"
        [state]="this.hasPrevious() ? 'classic' : 'disabled'"
        (action)="this.previous()"
      >
        {{ 'grid.cursor.previous' | translate }}
      </cam-button>

      <cam-button
        type="secondary"
        size="small"
        icon="arrow-big-right"
        iconPosition="right"
        [state]="this.hasNext() ? 'classic' : 'disabled'"
        (action)="this.next()"
      >
        {{ 'grid.cursor.next' | translate }}
      </cam-button>
    </div>
  </cam-loader>
}
